import {useSessionStore, useBoardStore, useMeetingStore} from '@/stores'
import {jsonRpc, mediator} from '@communication'
import {onMounted, onUnmounted} from 'vue'
import {useEventBus} from '@vueuse/core'

export const useStartSessionCallback = () => {
  const session = useSessionStore()
  const board = useBoardStore()

  useEventBus('session:time').on((event: any) => {
    session.setStartTimestamp(event.timestamp)
  })

  const onCallStateChanged = async (event: CustomEvent) => {
    const {state} = event.detail
    console.info(`Call state changed: ${state}`)
    if (state === 'IN_CALL') {
      // The server re-sends IN_CALL while the call goes on (each join attempt of a party, also a failed one): the call
      // and its snapshot are restored only when it (re)starts from the lobby, not again in the call or the drawing
      if (!useMeetingStore().isLobby) return
      useMeetingStore().startCall()
      const response = await mediator.sendAndWait({
        method: 'repository:fetchEvents',
        params: {
          type: 'snapshot',
        },
      })
      const history = JSON.parse(response)
      if (history.length) {
        history.sort((a: any, b: any) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime())
        const [last] = history
          .filter(({data: {type}}: any) => ['snapshot:take', 'snapshot:dismiss'].includes(type))
          .slice(-1)
        if (last?.data?.type === 'snapshot:take') {
          board.setDelayed(true)
          useMeetingStore().startDraw()
        }
      }
    } else if (state === 'LOBBY') {
      useMeetingStore().toLobby()
    }
  }
  onMounted(() => {
    jsonRpc.on('con:callState', onCallStateChanged)
  })
  onUnmounted(() => {
    jsonRpc.off('con:callState', onCallStateChanged)
  })
}
